import { checkIfProductionEnvironment } from 'src/lib/checkIfProductionEnvironment'
import { useSessionUID } from 'src/session/useSession'
import { ProviderRoleId, useCurrentRole } from './currentRole'
import { isActiveCareTeamMember } from './dashboard/careTeam/activeMember'
import { useCareTeamMembers } from './dashboard/careTeam/useCareTeamMembers'

const PROVIDER_ROLE_FOR_CATEGORY: Record<string, ProviderRoleId> = {
  therapist: 'therapist',
  nutritionist: 'nutritionist',
  psychiatrist: 'psychiatrist',
  coach: 'coach',
  'care-coordinator': 'careCoordinator',
  // Until the service's rename migration (ADR-138) has run everywhere; drop after that release.
  'care-navigator': 'careCoordinator',
}

export const usePatientRole = (uid: string): ProviderRoleId | undefined => {
  const [storedRole] = useCurrentRole()
  const viewerUid = useSessionUID()
  const { members } = useCareTeamMembers(uid)
  const membership = members.find((member) => member.providerUid === viewerUid && isActiveCareTeamMember(member))
  const careTeamRole = membership ? PROVIDER_ROLE_FOR_CATEGORY[membership.role] : undefined

  // Production never grants access based on the browser's simulated role.
  return checkIfProductionEnvironment() ? careTeamRole : storedRole
}
